module.exports = __webpack_public_path__ + "static/media/ts.b37fcd3d.jpg";